import { render, staticRenderFns } from "./DeviceEdit.vue?vue&type=template&id=4c5188a6&"
import script from "./DeviceEdit.vue?vue&type=script&lang=js&"
export * from "./DeviceEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeviceEdit.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports